import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultDashboardLayoutComponent } from '../dashboard/components/default-dashboard-layout/default-dashboard-layout.component';
import { CanLoadParameterCheckRouteService } from '../core/services/guard/can-load-parameter-check-route.base';
import { CanActiveAuthorizationModuleService } from 'projects/authentication/src/app/services/guard';

const routes: Routes = [
  {
    path: ':menu/extraccion/:zoneId',
    component: DefaultDashboardLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService],
  },
  {
    path: ':menu',
    component: DefaultDashboardLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService]
  },
  // TODO definir ruta para indicar un nombre de dashbaord erroneo 404
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
